import React, {useState} from "react";
import {debounce} from "lodash";
import { Slider } from "antd";
import { SliderValue } from "antd/lib/slider";
import {RangeSearchFieldType} from "../../../../types/configurations";
import {getPlaceholderForNumberFieldConfiguration, hasBeenFilled} from "../../../../helpers/dynamicFormHelper";
import InputNumber from "../../inputs/InputNumber";
import { FormikProps } from "formik/dist/types";

interface PropsType {
  fieldConfigurations: RangeSearchFieldType,
  disabled: boolean,
  forceDisabled: boolean,
  changeFilterDispatchActionHandler: any,
  formProps: FormikProps<any>
}

const RangeSearchField = (props: PropsType) => {
  const {
    fieldConfigurations,
    disabled,
    forceDisabled,
    changeFilterDispatchActionHandler,
    formProps: {
      values
    }
  } = props;

  const isInputDisabled = forceDisabled || (disabled && hasBeenFilled(values[fieldConfigurations.name]));
  const [sliderBounds, setSliderBounds] = useState(values[fieldConfigurations.name] || []);
  const [inputNumberBounds, setInputNumberBounds] = useState(sliderBounds);

  const [sliderLowerBound, sliderUpperBound] = sliderBounds;
  const [inputNumberLowerBound, inputNumberUpperBound] = inputNumberBounds;

  const [inputNumberLowerBoundPlaceholder, inputNumberUpperBoundPlaceholder] = getPlaceholderForNumberFieldConfiguration(fieldConfigurations).split(",");

  const minInputNumberLowerBound = fieldConfigurations.minValue;
  const maxInputNumberLowerBound = Math.min(fieldConfigurations.maxValue, sliderUpperBound || fieldConfigurations.maxValue)

  const minNumericUpperBound = Math.max(fieldConfigurations.minValue, sliderLowerBound || fieldConfigurations.minValue);
  const maxNumericUpperBound = fieldConfigurations.maxValue;

  const changeBounds = (newSliderBounds, newInputNumberBounds) => {
    setSliderBounds(newSliderBounds);
    setInputNumberBounds(newInputNumberBounds);
    debounce((nr) => {
      changeFilterDispatchActionHandler(fieldConfigurations.name, nr);
    }, 500)(hasBeenFilled(newInputNumberBounds) ? newInputNumberBounds : null);
  };

  return (
    <div className="range-search-field-container row m-0">
      <div className="col-3 px-0">
        <InputNumber
          className="form-control"
          value={inputNumberLowerBound}
          disabled={isInputDisabled}
          min={minInputNumberLowerBound}
          max={maxInputNumberLowerBound}
          step={fieldConfigurations.step}
          placeholder={inputNumberLowerBoundPlaceholder}
          name={`${fieldConfigurations.name}-min`}
          onChange={(newLowerBound) => {
            let newSliderBounds: any = [];
            let newInputNumberBounds: any = [];
            if (hasBeenFilled(newLowerBound)) {
              newSliderBounds = [newLowerBound, sliderUpperBound || maxInputNumberLowerBound];
              newInputNumberBounds = newSliderBounds;
            } else {
              newSliderBounds = (inputNumberUpperBound && [inputNumberUpperBound, inputNumberUpperBound]) || [];
              newInputNumberBounds = (inputNumberUpperBound && [null, inputNumberUpperBound]) || [];
            }
            changeBounds(newSliderBounds, newInputNumberBounds);
          }}
          onClear={() => {
            changeBounds([], [])
          }}
        />
      </div>
      <div className="col-6 px-1">
        <Slider
          range
          value={[sliderLowerBound, sliderUpperBound]}
          min={fieldConfigurations.minValue}
          max={fieldConfigurations.maxValue}
          step={fieldConfigurations.step}
          tooltipVisible={false}
          onChange={(newRange: SliderValue) => {
            if (!!newRange) {
              changeBounds(newRange, newRange);
            }
          }}
          disabled={isInputDisabled}
        />
      </div>
      <div className="col-3 px-0">
        <InputNumber
          className="form-control"
          value={inputNumberUpperBound}
          disabled={isInputDisabled}
          min={minNumericUpperBound}
          max={maxNumericUpperBound}
          step={fieldConfigurations.step}
          placeholder={inputNumberUpperBoundPlaceholder}
          name={`${fieldConfigurations.name}-max`}
          onChange={(newUpperBound) => {
            let newSliderBounds: any = [];
            let newInputNumberBounds: any = [];
            if (hasBeenFilled(newUpperBound)) {
              newSliderBounds = [sliderLowerBound || minNumericUpperBound, newUpperBound];
              newInputNumberBounds = newSliderBounds;
            } else {
              newSliderBounds = (inputNumberLowerBound && [inputNumberLowerBound, inputNumberLowerBound]) || [];
              newInputNumberBounds = (inputNumberLowerBound && [inputNumberLowerBound, null]) || [];
            }
            changeBounds(newSliderBounds, newInputNumberBounds);
          }}
          onClear={() => {
            changeBounds([], []);
          }}
        />
      </div>
    </div>
  );
};

export default RangeSearchField;
